import React from "react";
import "./Loader.css";

const Loader1=()=>{
    return(
        <div className="custom-loaderpres" />
    );
}

export default Loader1;